import { ColorValue } from "sharedTypes/badge"

/**
 * Color utility functions for BadgeBuilder
 * (hex helpers shared with the rest of the app live in utilities/colors)
 */

/**
 * Normalizes a value to ColorValue, using defaultValue as fallback.
 *
 * This is necessary because React Hook Form's field.value can be typed as
 * `T | undefined` even when defaultValue is provided, due to TypeScript's
 * conservative typing. In practice, with defaultValue, the value should
 * always exist, but we normalize to be safe.
 *
 * @param value - The value to normalize (from field.value or useWatch)
 * @param defaultValue - Fallback value if value is undefined/null
 * @returns Always returns a ColorValue (never undefined)
 */
const normalizeToColorValue = (
  value: unknown,
  defaultValue: ColorValue = "#000000",
): ColorValue => (value as ColorValue | undefined) || defaultValue

export default normalizeToColorValue
